import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { hasFullPanelAccess } from '../../auth/panelAccess';
import { useAuth } from '../../auth/AuthContext';
import PreviewHome from '../../pages/preview/PreviewHome';
import AppShell from '../shell/AppShell';

const PanelGate: React.FC = () => {
  const { user } = useAuth();
  const location = useLocation();

  if (hasFullPanelAccess(user)) {
    return <AppShell />;
  }

  if (location.pathname !== '/app') {
    return <Navigate to="/app" replace />;
  }

  return <PreviewHome />;
};

export default PanelGate;
